import * as React from 'react';

import List16 from './List16';

export const list16 = () => <List16 />;

export default {
    title: 'Icon/Line/List16',
    component: List16,
    parameters: {
        notes: "`import List16 from 'box-ui-elements/es/icon/line/List16';`",
    },
};
